import ExtendedPath from "csi/core/ExtendedPath";
import { CustomViewAttributesOptions } from "csi/middleware/customView/attributes/CustomViewAttributesStore";
import Widget from "csi/table/Widget";
import declare from "dojo/_base/declare";

const OMIT_TYPES = new Set([
	"AllergenItem",
	"CareSymbol",
	"Composition",
	"CompositionPlacement",
	"Food",
	"FoodAllergen",
	"FoodBOM",
	"FoodBOMLineItem",
	"FoodClaim",
	"FoodIngredient",
	"FoodLabelDataSheet",
	"FoodLabelItem",
	"FoodNutrient",
	"FormulatedMaterial",
	"IngredientItem",
	"LanguageMapLibItem",
	"MaterialBOM",
	"NutrientItem",
	"RecipeDataSheet",
	"RecipeLineItem",
	"TDSRevisionImpacted",
]);

const ImpactedItemsTable = declare(Widget, {
	/**
	 * @override
	 * Remove specified classes from Custom View
	 */
	onCustomViewAttributeOptions(options: CustomViewAttributesOptions): void {
		this.inherited(arguments);
		options.omitContainerCallback = (extendedPath: ExtendedPath): boolean => {
			const { endClass, endType } = extendedPath;
			const type = endClass.getMasterClass()?.type || endType;
			return OMIT_TYPES.has(type);
		};
	},
});

export = ImpactedItemsTable;
